module.exports = __webpack_public_path__ + "static/media/Oswald-Bold.c9575137.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Oswald-Bold.ttf
// module id = 6694
// module chunks = 2